import index from './SatelliteProfile';

export default index;
